import {Component, Input} from '@angular/core';

import {Word} from '../../models/word.model';
import {VoiceService} from '../../services/voice/voice.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";


@Component({
  selector: 'app-word-ex-play-btn',
  template: `
    <button type="button"
            [class.large]="large"
            *ngIf="show"
            (click)="playSound($event)">
      <i class="ic-speak {{ on ? 'on' : '' }}"></i>
    </button>
  `,
  styles: [
    `
      button {
        width: 2.3rem;
        height: 2.3rem;
        margin: 0.2rem 0;

        &.large {
          width: 3rem;
          height: 3rem;
        }
      }

      .ic-speak {
        background: url("../../../../img/btn_play.svg") no-repeat center / cover;
        width: 100%;
        height: 100%;

        &.on {
          background: url("../../../../img/btn_play.gif") no-repeat center / cover;
        }
      }
    `,
  ],
})
export class WordExPlayBtnComponent {
  @Input() word: Word | null = null;
  @Input() exNum: number | null = null; // 예문 음성 번호 (예문 번호, 문장 번호와는 무관한 음성의 순서)
  @Input() large: boolean = false;

  constructor(
    private voice: VoiceService,
    private globalEventSvc: GlobalEventService,
  ) { }

  public playSound(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (this.word) {
      if (this.on) {
        this.voice.Stop();
      }
      else {
        this.voice.PlaySound(this.word, this.exNum).subscribe();
      }
    }
    else {
      console.error('WordExPlayBtnComponent::playSound() invalid data', this);
    }
  }

  public get show(): boolean {
    return this?.exNum !== null && (this.word?.HaveExVoiceNth(this.exNum) ?? false);
  }

  public get on(): boolean {
    return this.voice.on && this.voice.wordId === this.word?.id && this.voice.noEx === this.exNum;
  }

}
